/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

import React, { createRef, RefObject } from "react";
import { baseUrl } from "./AssetLibrary";
import { ReactZoomPanPinchContentRef, TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

export class InlineImage extends React.Component<{ image: string; float: string; width: number | string; subscript: string; border: boolean; webp: boolean; inline: boolean }, {}> {
  static defaultProps = {
    float: "",
    width: "100%",
    border: true,
    subscript: null,
    webp: false,
    inline: false,
  };

  render(): React.ReactNode {
    const float = this.props.float;
    const width = this.props.width;
    const subscript = this.props.subscript;
    const border = this.props.border;
    const webp = this.props.webp;
    const inline = this.props.inline;
    let url = `${baseUrl}images/${this.props.image}`;

    // For webp support, use image with -normal.webp postfix instead
    if (webp) {
      url = url.replace(".jpg", "-normal.webp");
      url = url.replace(".jpeg", "-normal.webp");
      url = url.replace(".png", "-normal.webp");
    }
    let floatClass = "";
    if (float === "left") floatClass = "float-left ";
    if (float === "right") floatClass = "float-right ";
    let inlineClass = "";
    if (inline) inlineClass = "inline ";

    return (
      <div className={floatClass + inlineClass + "image-container"} style={{ width: width }}>
        <img src={url} className={`${border ? "border " : ""}zoom align-right inline-image`} alt={subscript} onClick={(e) => openFullscreen(url)} />
        <div className="subscript">{subscript}</div>
      </div>
    );
  }
}

const openFullscreen = (image: string) => {
  const container = document.getElementById("fullscreenContainer") as HTMLImageElement;
  container.requestFullscreen();
  const imageElem = document.getElementById("fullscreenImage") as HTMLElement;
  imageElem.style.backgroundImage = "url('" + image + "')";

  // For webp support, use image with -large.webp postfix instead
  imageElem.style.backgroundImage = imageElem.style.backgroundImage.replace("-normal.webp", "-large.webp");

  container.style.display = "block";
  document.addEventListener("fullscreenchange", fullscreenChanged);
};

function fullscreenChanged() {
  if (!document.fullscreenElement) {
    // If fullscreen was quit, ensure to hide the container
    const container = document.getElementById("fullscreenContainer") as HTMLElement;
    container.style.display = "none";
  }
}

export class FullscreenImage extends React.Component<{}, {}> {
  transformerRef = createRef() as RefObject<ReactZoomPanPinchContentRef> | undefined;

  closeFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    const container = document.getElementById("fullscreenContainer") as HTMLElement;
    container.style.display = "none";
    this.transformerRef?.current?.resetTransform();
  };

  render(): React.ReactNode {
    return (
      <div id="fullscreenContainer" className="fullscreenImage" onClick={this.closeFullscreen} style={{ display: "none" }}>
        <TransformWrapper initialScale={1} minScale={1} maxScale={10} centerOnInit={true} ref={this.transformerRef}>
          {() => (
            <TransformComponent>
              <div
                id="fullscreenImage"
                className="background"
                style={{
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  width: "100vw",
                  height: "100vh",
                }}
              ></div>
            </TransformComponent>
          )}
        </TransformWrapper>
      </div>
    );
  }
}
